<template>
  <div class="dnd-status-overlay" @click.self="$emit('close')">
    <div class="dnd-status-popup" role="dialog" aria-label="DND Status">
      <div class="dnd-status-header">
        <span>DND Status</span>
        <button type="button" aria-label="Close" @click="$emit('close')">
          <i class="fas fa-times"></i>
        </button>
      </div>
      <div class="dnd-status-body">
        <p v-if="loading">Loading…</p>
        <p v-else-if="error">{{ error }}</p>
        <p v-else-if="!rows.length">Nobody has Do Not Disturb on.</p>
        <ul v-else>
          <li v-for="row in rows" :key="row.key || row.userId">
            <div class="dnd-status-name">{{ row.name }}</div>
            <div
              v-for="(line, index) in row.lines"
              :key="index"
              class="dnd-status-line"
            >
              {{ line }}
            </div>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DndStatusPopup',
  props: {
    rows: { type: Array, default: () => [] },
    loading: { type: Boolean, default: false },
    error: { type: String, default: '' },
  },
  emits: ['close'],
};
</script>

<style scoped>
.dnd-status-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.35);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999;
}

.dnd-status-popup {
  width: min(360px, calc(100vw - 32px));
  max-width: 360px;
  background: #fff;
  color: #333;
  border-radius: 8px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.25);
}

.dnd-status-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: #6e5875;
  color: #fff;
  border-radius: 8px 8px 0 0;
  font-weight: 600;
}

.dnd-status-header button {
  border: none;
  background: transparent;
  color: #fff;
  cursor: pointer;
  font-size: 14px;
}

.dnd-status-body {
  padding: 12px;
  max-height: 320px;
  overflow: auto;
  font-size: 13px;
}

.dnd-status-body ul {
  list-style: none;
  margin: 0;
  padding: 0;
}

.dnd-status-body li + li {
  margin-top: 10px;
  padding-top: 10px;
  border-top: 1px solid #eee;
}

.dnd-status-name {
  font-weight: 600;
}

.dnd-status-line {
  color: #555;
}
</style>
